import { Component, Input, OnInit } from '@angular/core';

interface HistoricData {
  mes: number;
  quantidade: number;
}

@Component({
  selector: 'app-historic-modal-section',
  templateUrl: './historic-modal-section.component.html',
  styleUrls: ['./historic-modal-section.component.scss']
})
export class HistoricSectionComponent implements OnInit {
  @Input() data: HistoricData[] = [];
  @Input() label = '';

  constructor() { }

  ngOnInit() {
  }

}
